import { render, staticRenderFns } from "./MainPageStat.vue?vue&type=template&id=3b37f951&scoped=true"
import script from "./MainPageStat.vue?vue&type=script&lang=js"
export * from "./MainPageStat.vue?vue&type=script&lang=js"
import style0 from "./MainPageStat.vue?vue&type=style&index=0&id=3b37f951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37f951",
  null
  
)

export default component.exports